export const Loader = ({ size = 'md', color = 'blue' }: { size?: 'xs' | 'sm' | 'md' | 'lg'; color?: string }) => {
  const sizeClasses = {
    xs: 'w-4 h-4 border-1',
    sm: 'w-6 h-6 border-2',
    md: 'w-10 h-10 border-4',
    lg: 'w-16 h-16 border-[6px]',
  };

  return (
    <div data-testid="loader" className="flex items-center justify-center">
      <div
        data-testid="loader-spinner"
        className={`animate-spin rounded-full border-transparent border-t-${color} ${sizeClasses[size]}`}
        style={{ borderTopColor: `var(--color-${color})` }}
      />
    </div>
  );
};
